var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTemplateDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 440,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1300v440H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#b)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#c)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#d)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#e)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#f)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.08 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#g)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L.93 451.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#h)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#i)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#j)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#k)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.92 400.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#l)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.92 400.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#m)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.92 400.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#n)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.92 400.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#o)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#p)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#q)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#r)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#s)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#t)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#u)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15L1.07 451.06a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L.92 350.93l-.64-.63.64.63Z",
    fill: "url(#v)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#w)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#x)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.92 350.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#y)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.92 350.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#z)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.92 350.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#A)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.92 350.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#B)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.92 350.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#C)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#D)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#E)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#F)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#G)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#H)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.08 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#I)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L.93 351.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#J)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#K)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#L)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#M)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.92 300.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#N)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.92 300.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#O)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.92 300.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#P)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.92 300.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#Q)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#R)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#S)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#T)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#U)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#V)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#W)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15L1.07 351.06a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L.92 250.93l-.64-.63.64.63Z",
    fill: "url(#X)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#Y)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#Z)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.92 250.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aa)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.92 250.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ab)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.92 250.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ac)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.92 250.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ad)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.92 250.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ae)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#af)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ag)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ah)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ai)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aj)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.08 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ak)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L.93 251.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#al)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#am)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#an)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ao)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.92 200.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ap)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.92 200.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aq)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.92 200.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ar)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#as)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#at)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#au)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#av)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aw)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ax)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15L1.07 251.06a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L.92 150.93l-.64-.63.64.63Z",
    fill: "url(#ay)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#az)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aA)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.92 150.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aB)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.92 150.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aC)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.92 150.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aD)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.92 150.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aE)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.92 150.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aF)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aG)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aH)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aI)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aJ)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.08 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aK)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L.93 151.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aL)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aM)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aN)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aO)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aP)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.92 100.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aQ)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.92 100.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aR)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.92 100.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aS)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aT)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aU)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aV)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aW)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aX)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aY)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#aZ)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#ba)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bb)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.92 50.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bc)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.92 50.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bd)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.92 50.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#be)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.92 50.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bf)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L450.92.93l-.64-.63.64.63Z",
    fill: "url(#bg)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L550.92.93l-.64-.63.64.63Z",
    fill: "url(#bh)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L650.92.93l-.64-.63.64.63Z",
    fill: "url(#bi)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L750.92.93l-.64-.63.64.63Z",
    fill: "url(#bj)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L850.92.93l-.64-.63.64.63Z",
    fill: "url(#bk)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.08.93a.11.11 0 0 1 .15 0L1.06 50.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L-49.08.93l-.64-.63.64.63Z",
    fill: "url(#bl)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L.93 51.07a.11.11 0 0 1 0-.15l-.63-.64.63.64L50.92.93 50.28.3l.64.63Z",
    fill: "url(#bm)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L150.92.93l-.64-.63.64.63Z",
    fill: "url(#bn)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L250.92.93l-.64-.63.64.63Z",
    fill: "url(#bo)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L350.92.93l-.64-.63.64.63Z",
    fill: "url(#bp)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.92.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L950.92.93l-.64-.63.64.63Z",
    fill: "url(#bq)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.92.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64L1150.92.93l-.64-.63.64.63Z",
    fill: "url(#br)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.92.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64L1250.92.93l-.64-.63.64.63Z",
    fill: "url(#bs)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.92-49.07a.11.11 0 0 1 .15 0L551.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L450.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bt)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.92-49.07a.11.11 0 0 1 .15 0L651.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L550.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bu)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.92-49.07a.11.11 0 0 1 .15 0L751.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L650.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bv)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.92-49.07a.11.11 0 0 1 .15 0L851.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L750.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bw)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92-49.07a.11.11 0 0 1 .15 0L151.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L50.93 1.07a.11.11 0 0 1 0-.15L50.3.28l.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bx)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92-49.07a.11.11 0 0 1 .15 0L251.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L150.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#by)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.92-49.07a.11.11 0 0 1 .15 0L51.06.92c.04.04.04.11 0 .15L1.07 51.06a.11.11 0 0 1-.15 0L-49.07 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64L.92-49.07l-.64-.63.64.63Z",
    fill: "url(#bz)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92-49.07a.11.11 0 0 1 .15 0L351.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L250.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bA)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92-49.07a.11.11 0 0 1 .15 0L451.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L350.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bB)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.92-49.07a.11.11 0 0 1 .15 0L951.06.92c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0L850.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bC)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.92-49.07a.1.1 0 0 1 .15 0L1051.06.92c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0L950.93 1.07a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bD)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.92-49.07a.1.1 0 0 1 .15 0L1151.06.92c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bE)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.92-49.07a.1.1 0 0 1 .15 0L1251.06.92c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bF)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.92-49.07a.1.1 0 0 1 .15 0L1351.06.92c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    fill: "url(#bG)",
    stroke: "#1C1C1C",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.92 50.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15L1.07 151.06a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64L.92 50.93l-.64-.63.64.63Z",
    fill: "url(#bH)",
    stroke: "#272727",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.28 100.3a1 1 0 0 1 1.43 0l49.98 49.98a1 1 0 0 1 0 1.43l-49.98 49.98a1 1 0 0 1-1.43 0l-49.98-49.98a1 1 0 0 1 0-1.43l49.98-49.98Z",
    fill: "url(#bJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.92 100.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    stroke: "#272727",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bK)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050.28.3c.4-.4 1.03-.4 1.43 0l49.98 49.98a1 1 0 0 1 0 1.43l-49.98 49.98c-.4.4-1.03.4-1.43 0l-49.98-49.98a1 1 0 0 1 0-1.43L1050.28.3Z",
    fill: "url(#bL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.92.93a.1.1 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.1.1 0 0 1-.15 0l-49.99-49.99a.12.12 0 0 1 0-.15l-.63-.64.63.64L1050.92.93l-.64-.63.64.63Z",
    stroke: "#272727",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bM)",
    d: "M2 0h1300v440H2z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 1299 0)",
    fill: "url(#bN)",
    d: "M1299 0h440v650h-440z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 1 1 0 0 0)",
    fill: "url(#bO)",
    d: "M0 0h440v650H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bP)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.28 200.3a1 1 0 0 1 1.43 0l49.98 49.98a1 1 0 0 1 0 1.43l-49.98 49.98a1 1 0 0 1-1.43 0l-49.98-49.98a1 1 0 0 1 0-1.43l49.98-49.98Z",
    fill: "url(#bQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92 200.93a.11.11 0 0 1 .15 0l49.99 49.99c.04.04.04.11 0 .15l-49.99 49.99a.11.11 0 0 1-.15 0l-49.99-49.99a.11.11 0 0 1 0-.15l-.63-.64.63.64 49.99-49.99-.64-.63.64.63Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 1 1 0 0 0)",
    fill: "url(#bR)",
    d: "M0 0h440v650H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 1299 0)",
    fill: "url(#bS)",
    d: "M1299 0h440v650h-440z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 1300 66)",
    fill: "url(#bT)",
    d: "M1300 66h374v650h-374z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 1 1 0 0 66)",
    fill: "url(#bU)",
    d: "M0 0h374v650H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 1299 0)",
    fill: "url(#bV)",
    d: "M1299 0h440v1299h-440z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bW)",
    d: "M0 374h1300v66H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1437.34-8.27s-117.05 63.8-155.88 83.99c-71.11 36.97-182.51 73-258.76 83.78-83.11 11.75-107.01 14.93-190.69 16.05-53.3.71-130.87-20.52-130.87-20.52s-67.6-11.09-92.74-26.71c-23.25-14.45-29.73-26.44-29.73-26.44L596.04-25.4l76.2-134.56 631.24-39.25L1532-231.94 1437.34-8.27Z",
    fill: "url(#bY)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bZ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-101.34-8.26S15.71 55.53 54.53 75.72c71.12 36.97 182.52 73 258.77 83.78 83.11 11.75 166.83 24.18 250.5 25.3 53.3.71 79.08-52.33 79.08-52.33s55.72 3.17 80.86-12.46c23.25-14.45 32.7-56.47 32.7-56.47l-16.48-88.95-76.2-134.55-631.24-39.26L-196-231.94l94.66 223.68Z",
    fill: "url(#ca)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342 111.9s82.74 42.43 139.29 59.1c57.31 16.88 90.96 26.79 150.55 25.8 54.33-.9 86.08-5.86 136.87-25.8C829.61 147.06 908 76.1 908 76.1L732.48-75.39H500.61L342 111.9Z",
    fill: "url(#cc)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1437.34-93.72s-117.05 48.74-155.88 64.16c-71.11 28.25-182.51 55.78-258.76 64.01-83.11 8.98-107.01 11.41-190.69 12.27-53.3.54-130.87-15.68-130.87-15.68s-67.6-8.47-92.74-20.4c-23.25-11.05-29.73-20.2-29.73-20.2l17.37-97.26 76.2-102.8 631.24-30L1532-264.6l-94.66 170.89Z",
    fill: "url(#ce)",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-101.34-93.72S15.71-44.98 54.53-29.56C125.65-1.3 237.05 26.22 313.3 34.45c83.11 8.98 166.83 18.47 250.5 19.33 53.3.55 79.08-39.98 79.08-39.98s55.72 2.42 80.86-9.51c23.25-11.05 32.7-43.15 32.7-43.15l-16.48-67.96-76.2-102.8-631.24-30L-196-264.6l94.66 170.89Z",
    fill: "url(#cg)",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ch)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342-1.92s82.74 32.43 139.29 45.15c57.31 12.9 90.96 20.48 150.55 19.72 54.33-.7 86.08-4.47 136.87-19.72C829.61 24.96 908-29.27 908-29.27L732.48-145H500.61L342-1.92Z",
    fill: "url(#ci)",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 451.08,
    y1: 399.58,
    x2: 451.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 551.08,
    y1: 399.58,
    x2: 551.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 651.08,
    y1: 399.58,
    x2: 651.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 751.08,
    y1: 399.58,
    x2: 751.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 851.08,
    y1: 399.58,
    x2: 851.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -48.92,
    y1: 399.58,
    x2: -48.92,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 51.08,
    y1: 399.58,
    x2: 51.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 151.08,
    y1: 399.58,
    x2: 151.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 251.08,
    y1: 399.58,
    x2: 251.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 351.08,
    y1: 399.58,
    x2: 351.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 951.08,
    y1: 399.58,
    x2: 951.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 1051.08,
    y1: 399.58,
    x2: 1051.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1151.08,
    y1: 399.58,
    x2: 1151.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 1251.08,
    y1: 399.58,
    x2: 1251.08,
    y2: 502.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 501.08,
    y1: 349.58,
    x2: 501.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 601.08,
    y1: 349.58,
    x2: 601.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 701.08,
    y1: 349.58,
    x2: 701.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 801.08,
    y1: 349.58,
    x2: 801.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 101.08,
    y1: 349.58,
    x2: 101.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 201.08,
    y1: 349.58,
    x2: 201.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 1.08,
    y1: 349.58,
    x2: 1.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 301.08,
    y1: 349.58,
    x2: 301.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 401.08,
    y1: 349.58,
    x2: 401.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 901.08,
    y1: 349.58,
    x2: 901.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 1001.08,
    y1: 349.58,
    x2: 1001.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 1101.08,
    y1: 349.58,
    x2: 1101.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 1201.08,
    y1: 349.58,
    x2: 1201.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 1301.08,
    y1: 349.58,
    x2: 1301.08,
    y2: 452.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 451.08,
    y1: 299.58,
    x2: 451.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 551.08,
    y1: 299.58,
    x2: 551.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 651.08,
    y1: 299.58,
    x2: 651.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 751.08,
    y1: 299.58,
    x2: 751.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 851.08,
    y1: 299.58,
    x2: 851.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: -48.92,
    y1: 299.58,
    x2: -48.92,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 51.08,
    y1: 299.58,
    x2: 51.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 151.08,
    y1: 299.58,
    x2: 151.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 251.08,
    y1: 299.58,
    x2: 251.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 351.08,
    y1: 299.58,
    x2: 351.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 951.08,
    y1: 299.58,
    x2: 951.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 1051.08,
    y1: 299.58,
    x2: 1051.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 1151.08,
    y1: 299.58,
    x2: 1151.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 1251.08,
    y1: 299.58,
    x2: 1251.08,
    y2: 402.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 501.08,
    y1: 249.58,
    x2: 501.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 601.08,
    y1: 249.58,
    x2: 601.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 701.08,
    y1: 249.58,
    x2: 701.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 801.08,
    y1: 249.58,
    x2: 801.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 101.08,
    y1: 249.58,
    x2: 101.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 201.08,
    y1: 249.58,
    x2: 201.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 1.08,
    y1: 249.58,
    x2: 1.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 301.08,
    y1: 249.58,
    x2: 301.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 401.08,
    y1: 249.58,
    x2: 401.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 901.08,
    y1: 249.58,
    x2: 901.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 1001.08,
    y1: 249.58,
    x2: 1001.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 1101.08,
    y1: 249.58,
    x2: 1101.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 1201.08,
    y1: 249.58,
    x2: 1201.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 1301.08,
    y1: 249.58,
    x2: 1301.08,
    y2: 352.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 451.08,
    y1: 199.58,
    x2: 451.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 551.08,
    y1: 199.58,
    x2: 551.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 651.08,
    y1: 199.58,
    x2: 651.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 751.08,
    y1: 199.58,
    x2: 751.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 851.08,
    y1: 199.58,
    x2: 851.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: -48.92,
    y1: 199.58,
    x2: -48.92,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 51.08,
    y1: 199.58,
    x2: 51.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 151.08,
    y1: 199.58,
    x2: 151.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 251.08,
    y1: 199.58,
    x2: 251.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 951.08,
    y1: 199.58,
    x2: 951.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 1051.08,
    y1: 199.58,
    x2: 1051.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 1151.08,
    y1: 199.58,
    x2: 1151.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 1251.08,
    y1: 199.58,
    x2: 1251.08,
    y2: 302.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 501.08,
    y1: 149.58,
    x2: 501.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 601.08,
    y1: 149.58,
    x2: 601.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 701.08,
    y1: 149.58,
    x2: 701.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 801.08,
    y1: 149.58,
    x2: 801.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 101.08,
    y1: 149.58,
    x2: 101.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 201.08,
    y1: 149.58,
    x2: 201.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 1.08,
    y1: 149.58,
    x2: 1.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 301.08,
    y1: 149.58,
    x2: 301.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 401.08,
    y1: 149.58,
    x2: 401.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 901.08,
    y1: 149.58,
    x2: 901.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 1001.08,
    y1: 149.58,
    x2: 1001.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 1101.08,
    y1: 149.58,
    x2: 1101.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 1201.08,
    y1: 149.58,
    x2: 1201.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 1301.08,
    y1: 149.58,
    x2: 1301.08,
    y2: 252.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 451.08,
    y1: 99.58,
    x2: 451.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 551.08,
    y1: 99.58,
    x2: 551.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 651.08,
    y1: 99.58,
    x2: 651.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 751.08,
    y1: 99.58,
    x2: 751.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: -48.92,
    y1: 99.58,
    x2: -48.92,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 51.08,
    y1: 99.58,
    x2: 51.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 151.08,
    y1: 99.58,
    x2: 151.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 251.08,
    y1: 99.58,
    x2: 251.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 351.08,
    y1: 99.58,
    x2: 351.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 951.08,
    y1: 99.58,
    x2: 951.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 1051.08,
    y1: 99.58,
    x2: 1051.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 1151.08,
    y1: 99.58,
    x2: 1151.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 1251.08,
    y1: 99.58,
    x2: 1251.08,
    y2: 202.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 501.08,
    y1: 49.58,
    x2: 501.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 601.08,
    y1: 49.58,
    x2: 601.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 701.08,
    y1: 49.58,
    x2: 701.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 801.08,
    y1: 49.58,
    x2: 801.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 101.08,
    y1: 49.58,
    x2: 101.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 201.08,
    y1: 49.58,
    x2: 201.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 301.08,
    y1: 49.58,
    x2: 301.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 401.08,
    y1: 49.58,
    x2: 401.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 901.08,
    y1: 49.58,
    x2: 901.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 1001.08,
    y1: 49.58,
    x2: 1001.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 1101.08,
    y1: 49.58,
    x2: 1101.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 1201.08,
    y1: 49.58,
    x2: 1201.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 1301.08,
    y1: 49.58,
    x2: 1301.08,
    y2: 152.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 451.08,
    y1: -0.42,
    x2: 451.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 551.08,
    y1: -0.42,
    x2: 551.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 651.08,
    y1: -0.42,
    x2: 651.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 751.08,
    y1: -0.42,
    x2: 751.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 851.08,
    y1: -0.42,
    x2: 851.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: -48.92,
    y1: -0.42,
    x2: -48.92,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 51.08,
    y1: -0.42,
    x2: 51.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 151.08,
    y1: -0.42,
    x2: 151.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 251.08,
    y1: -0.42,
    x2: 251.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 351.08,
    y1: -0.42,
    x2: 351.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 951.08,
    y1: -0.42,
    x2: 951.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 1151.08,
    y1: -0.42,
    x2: 1151.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 1251.08,
    y1: -0.42,
    x2: 1251.08,
    y2: 102.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 501.08,
    y1: -50.42,
    x2: 501.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 601.08,
    y1: -50.42,
    x2: 601.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 701.08,
    y1: -50.42,
    x2: 701.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 801.08,
    y1: -50.42,
    x2: 801.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 101.08,
    y1: -50.42,
    x2: 101.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 201.08,
    y1: -50.42,
    x2: 201.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 1.08,
    y1: -50.42,
    x2: 1.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 301.08,
    y1: -50.42,
    x2: 301.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 401.08,
    y1: -50.42,
    x2: 401.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 901.08,
    y1: -50.42,
    x2: 901.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 1001.08,
    y1: -50.42,
    x2: 1001.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 1101.08,
    y1: -50.42,
    x2: 1101.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 1201.08,
    y1: -50.42,
    x2: 1201.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 1301.08,
    y1: -50.42,
    x2: 1301.08,
    y2: 52.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: -37.5,
    y1: 82.5,
    x2: 57.5,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 867,
    y1: 129,
    x2: 797.5,
    y2: 236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 1046,
    y1: 0,
    x2: 1070,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 665.5,
    y1: 102,
    x2: 665.5,
    y2: 599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 343.5,
    y1: 190.5,
    x2: 359.5,
    y2: 325.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 62.5,
    y1: -301.64,
    x2: 62.5,
    y2: 688.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 1361.5,
    y1: -301.64,
    x2: 1361.5,
    y2: 688.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 1727.37,
    y1: 119.63,
    x2: 1417.23,
    y2: 216.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#121212",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#121212",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#121212",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 427.37,
    y1: 53.63,
    x2: 117.23,
    y2: 150.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#121212",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#121212",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#121212",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 662,
    y1: 331.29,
    x2: 662,
    y2: 491.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0E0E0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0E0E0E",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0E0E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 584.16,
    y1: -4.4,
    x2: 1445.19,
    y2: 40.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#589E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: -183.27,
    y1: 14.53,
    x2: 750.11,
    y2: 8.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2590AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 1018.3,
    y1: 75.83,
    x2: 211.57,
    y2: 82.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#589E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2590AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 584.16,
    y1: -90.77,
    x2: 1443.56,
    y2: -32.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#589E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: -183.27,
    y1: -76.3,
    x2: 750.08,
    y2: -83.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2590AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2590AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 1018.3,
    y1: -29.47,
    x2: 211.61,
    y2: -20.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#589E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2590AC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bI",
    x: 793,
    y: 97,
    width: 115.99,
    height: 115.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.69 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_847_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_847_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bK",
    x: 991,
    y: -3,
    width: 119.99,
    height: 119.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.69 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_847_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_847_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bP",
    x: 294,
    y: 200,
    width: 113.99,
    height: 116.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.69 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_847_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_847_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bX",
    x: 468.67,
    y: -341.94,
    width: 1173.33,
    height: 627.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_847_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bZ",
    x: -306,
    y: -341.94,
    width: 1172.43,
    height: 636.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_847_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cb",
    x: 232,
    y: -185.38,
    width: 786,
    height: 492.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_847_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cd",
    x: 468.67,
    y: -374.61,
    width: 1173.33,
    height: 531.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_847_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cf",
    x: -306,
    y: -374.61,
    width: 1172.43,
    height: 538.39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_847_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ch",
    x: 232,
    y: -255,
    width: 786,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55,
    result: "effect1_foregroundBlur_847_2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-377.50332 784.56917 -1247.39528 -600.19674 1739 -95.98)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-377.50332 784.56917 -1247.39528 -600.19674 440 -95.98)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -606.723 386.5 0 1352.5 606.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6FF9F",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E0FF9F",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1300v440H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTemplateDark);
export default __webpack_public_path__ + "static/media/bg-template__dark.b587afe850ebabcf9d1a029bcabcfd59.svg";
export { ForwardRef as ReactComponent };